export default "__VITE_ASSET__CJX9Fj6k__"